import React, { FC, useEffect, useRef, useState } from "react";
import {
  Input,
  Modal,
  Row,
  Col,
  Button,
  Spin
} from "antd";
import { CloseOutlined, MailOutlined, SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";

import {
  GET_FRIEND_PAGE,
  GET_AGGREGATE
} from "reducers/authReducer";
import { RootState } from "reducers/rootReducer";
import {
  wrapRequestPayload,
} from "../../helpers/request/RequestPayload";
import { SocketTopics } from "../../constants/enums";

import { generateUUID, formatUserFilterText } from "utils/appUtil";
import AvatarItem from "./AvatarItem";
import InvitePeopleModal from "./InvitePeopleModal";

let timeout;
const PeopleListModal: FC<{ onClose: () => void; socket?: ISocket }> = ({
  onClose,
  socket,
}) => {
  const { selectedItem } = useSelector(
    (state: RootState) => state.search
  );
  const { findUsersToPage, searchBds, allUsers } = useSelector(
    (state: RootState) => state.auth
  );
  const scrollRef = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [isInviteOpen, setIsInviteOpen] = useState(false);
  const { projects } = useSelector((state: RootState) => state.dashboard);
  const { requestIds } = useSelector((state: RootState) => state.dashboard);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState<any[]>([
    { id: localStorage.getItem("RID") },
  ]);
  const [combinedUsers, setCombinedUsers] = useState<any[]>([]);
  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (allUsers?.length) {
      let usersList = allUsers as any[];
      setCombinedUsers(usersList);
      console.log("allUsers", usersList);
    }
  }, [allUsers]);


  // const aggregateUser = (inputQueryId: string, filterText?: string) => {
  //   var searchQuery = `@userType:{user}`;
  //   if (filterText && filterText.length > 2) {
  //     searchQuery += formatUserFilterText(filterText);
  //   }
  //   console.log('test', {
  //     select: {
  //       index: {
  //         searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
  //         searchQuery: searchQuery,
  //         searchOptions: "TIMEOUT 10000",
  //       },
  //       list: {
  //         inputQueryId: inputQueryId,
  //       },
  //       load: {
  //         objectId: "$.objectId",
  //         liveObject: "$.persistent.static",
  //         status: "$.nonpersistent.static.live.status"
  //       },
  //     },
  //     groupBy: {
  //       properties: ["@objectId"],
  //       reducers: [
  //         {
  //           func: "TOLIST",
  //           arguments: ["@liveObject"],
  //           name: "profile",
  //         },
  //       ],
  //     },
  //     apply: {
  //       expression: "",
  //       name: "",
  //     },
  //     filter: {
  //       expression: "",
  //     },
  //     result: {
  //       pagination: {
  //         offset: 0,
  //         limit: 10000,
  //       },
  //     },
  //     anyStatus: false,
  //   });

  //   socket.publishToEvent(
  //     SocketTopics.PublishPageTopics,
  //     `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
  //       "CID"
  //     )}/service/bds/aggregateBds`,
  //     wrapRequestPayload({
  //       select: {
  //         index: {
  //           searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
  //           searchQuery: searchQuery,
  //           searchOptions: "TIMEOUT 10000",
  //         },
  //         list: {
  //           inputQueryId: inputQueryId,
  //         },
  //         load: {
  //           objectId: "$.objectId",
  //           liveObject: "$.persistent.static",
  //           status: "$.nonpersistent.static.live.status"
  //         },
  //       },
  //       groupBy: {
  //         properties: ["@objectId"],
  //         reducers: [
  //           {
  //             func: "TOLIST",
  //             arguments: ["@liveObject"],
  //             name: "profile",
  //           },
  //         ],
  //       },
  //       apply: {
  //         expression: "",
  //         name: "",
  //       },
  //       filter: {
  //         expression: "",
  //       },
  //       result: {
  //         pagination: {
  //           offset: 0,
  //           limit: 10000,
  //         },
  //       },
  //       anyStatus: false,
  //     }, requestIds.user)
  //   );
  // };

  // useEffect(() => {
  //   if (!findUsersToPage) {
  //     findUsers([projects?.userServiceId]);
  //   }
  // }, []);

  // useEffect(() => {
  //   if (findUsersToPage) {
  //     aggregateUser(findUsersToPage.queryId);
  //   }
  // }, [findUsersToPage]);

  const formatAggregateUserResponse = (response) => {
    let resolvedData = [];
    let profiles = [];
    response?.map((user) => {
      if (Array.isArray(user?.profile)) {
        let temp = {
          objectIds: user?.objectId,
          status: user?.status,
          profile: undefined,
          email: undefined,
          phone: undefined,
          profileImage: undefined,
          beamIds: undefined,
          roleId: undefined,
          department: undefined,
        };
        user?.profile.map((x) => {
          const parsed = JSON.parse(x)?.live;
          const admin = JSON.parse(x)?.admin;
          if (parsed?.alternativeIds?.email) {
            temp.email = parsed?.alternativeIds?.email
          }
          if (parsed?.alternativeIds?.phone) {
            temp.phone = parsed?.alternativeIds?.phone
          }
          if (parsed?.profile?.firstName || parsed?.profile?.firstName) {
            temp.profile = parsed?.profile
          }
          if (parsed?.beamIds?.[0]) {
            temp.beamIds = parsed?.beamIds
          }
          if (parsed?.profile?.profileImage?.urls?.original?.url) {
            temp.profileImage = parsed?.profile?.profileImage;
          }
          if (admin?.profile?.roleId) {
            temp.roleId = admin?.profile?.roleId;
          }
        });
        if (temp) {
          profiles.push(temp);
        }
      } else {
        profiles.push({
          objectIds: user.objectId,
          status: user?.status,
          profile: user?.profile?.live?.profile,
          beamIds: user?.profile?.live?.beamIds,
          email: user?.profile?.live?.alternativeIds?.email,
          phone: user?.profile?.live?.alternativeIds?.phone,
          profileImage: user?.profile?.live?.profile?.profileImage,
          roleId: user?.profile?.admin?.profile?.roleId
        });
      }
    });
    try {
      resolvedData = profiles
        ?.filter((user) => {
          return user.email || user.phone || user.beamIds?.[0] || user.profile?.firstName || user.profile?.lastName;
        })
        ?.map((user) => {
          return {
            id: user.objectIds.toString(),
            name:
              user?.profile?.firstName || user.profile?.lastName
                ? (user?.profile?.firstName || "") +
                " " +
                (user.profile?.lastName || "")
                : `user# ${user.objectIds.toString()}`,
            firstName: user?.profile?.firstName ?? "",
            lastName: user?.profile?.lastName ?? "",
            gender: user?.profile?.gender ?? "",
            dob: user?.profile?.dob ?? "",
            email: user.email,
            phone: user.phone,
            beamId:
              user?.beamIds?.[0]?.toLowerCase() ||
              (
                user?.profile?.firstName || user.profile?.lastName
                  ? (user?.profile?.firstName?.toLowerCase() || "") +
                  "." +
                  (user.profile?.lastName?.toLowerCase() || "")
                  : `user# ${user.objectIds.toString()}`
              ),
            profileImage: user?.profileImage ?? {},
            roleId: user?.roleId,
            status: user?.status,
          };
        });
    } catch (e) {
      console.log("something went wrong");
    }

    resolvedData.sort((a, b) => (a.beamId > b.beamId) ? 1 : ((b.beamId > a.beamId) ? -1 : 0))
    return resolvedData;
  }

  const aggregateUser = (inputQueryId: string, filterText?: string) => {


    var searchQuery = `@userType:{user}`;
    if (filterText) {
      if (filterText.length > 2) {
        searchQuery += formatUserFilterText(filterText);
      } else if (filterText.length > 0 && filterText.length <= 2) {
        return;
      }
    }

    setIsLoading(true);

    dispatch(GET_AGGREGATE({
      requestData: {
        select: {
          index: {
            searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
            searchQuery: searchQuery,
            searchOptions: "TIMEOUT 10000",
          },
          list: {
            inputQueryId: inputQueryId,
          },
          load: {
            objectId: "$.objectId",
            liveObject: "$.persistent.static",
            status: "$.nonpersistent.static.live.status",
          },
        },
        groupBy: {
          properties: ["@objectId"],
          reducers: [
            {
              func: "TOLIST",
              arguments: ["@liveObject"],
              name: "profile",
            },
          ],
        },
        apply: {
          expression: "",
          name: "",
        },
        filter: {
          expression: "",
        },
        result: {
          pagination: {
            offset: 0,
            limit: 10000,
          },
        },
        anyStatus: false,
      },
      callback: (response) => {
        const formattedResponse = formatAggregateUserResponse(response);
        console.log("aggregate user response", formattedResponse);
        setCombinedUsers(formattedResponse);
        setIsLoading(false);
      },
    }));

    // socket.publishToEvent(
    //   SocketTopics.PublishPageTopics,
    //   `${process.env.REACT_APP_ECO_SYSTEM}/connection/${localStorage.getItem(
    //     "CID"
    //   )}/service/bds/aggregateBds`,
    //   wrapRequestPayload(
    //     {
    //       select: {
    //         index: {
    //           searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
    //           searchQuery: searchQuery,
    //           searchOptions: "TIMEOUT 10000",
    //         },
    //         list: {
    //           inputQueryId: inputQueryId,
    //         },
    //         load: {
    //           objectId: "$.objectId",
    //           liveObject: "$.persistent.static",
    //           status: "$.nonpersistent.static.live.status",
    //         },
    //       },
    //       groupBy: {
    //         properties: ["@objectId"],
    //         reducers: [
    //           {
    //             func: "TOLIST",
    //             arguments: ["@liveObject"],
    //             name: "profile",
    //           },
    //         ],
    //       },
    //       apply: {
    //         expression: "",
    //         name: "",
    //       },
    //       filter: {
    //         expression: "",
    //       },
    //       result: {
    //         pagination: {
    //           offset: 0,
    //           limit: 10000,
    //         },
    //       },
    //       anyStatus: false,
    //     },
    //     requestIds.user
    //   )
    // );
  };


  const openChat = (user) => {
    dispatch(GET_FRIEND_PAGE({ friendUserId: user.id }));
    handleCancel();
  };

  return (
    <React.Fragment>
      <Modal
        title=""
        visible={isModalVisible}
        onOk={() => { }}
        onCancel={handleCancel}
        width="480px"
        className="beam-modal scrollable"
        footer={[]}
        closable={false}
        destroyOnClose={true}
      >

        {!isInviteOpen && (
          <div>
            <Row className="d-flex mt-1 mb-4">
              <Col span={24}>
                <h3>Friends
                  <button onClick={onClose} className="pull-right b-0 rm-b"><CloseOutlined /></button>
                </h3>
              </Col>
            </Row>

            <Row>
        <Col span={24}>
          {isLoading && (
            <div id="loading">
              <Spin className="mt-5" tip="Loading">
                <div className="content" />
              </Spin>
            </div>
          )}
        </Col>
      </Row>

            <Row>
              <Col span={16}>
                <Input
                  onChange={(e) => {
                    const value: string = e.target.value;
                    // if (value === undefined || value === '') return;
                    if (findUsersToPage) {
                      if (timeout) clearTimeout(timeout);
                      timeout = setTimeout(() => {
                        aggregateUser(findUsersToPage.queryId, value);
                      }, 500)
                    }
                  }}
                  placeholder="Search"
                  suffix={<SearchOutlined />}
                  allowClear
                />
              </Col>
              <Col span={8}>
                <Button onClick={() => setIsInviteOpen(true)} className="beam-btn orange-btn bordered ml-2"><MailOutlined className="p-1 mb-2" />Invite</Button>
              </Col>
            </Row>
            <Row className="scrollable-body mt-4" ref={scrollRef}>
              <Col span={24}>
                <React.Fragment>
                  {combinedUsers &&
                    combinedUsers.map(
                      (user, index) =>
                        !Object.keys(selectedUsers).find(
                          (item) => item === user.id
                        ) && (
                          <AvatarItem isPrivateChat={true} index={index} key={user.id}
                            socket={socket}
                            user={user} onChat={() => openChat(user)}
                            selectedItem={selectedItem}
                            onCloseParentModal={onClose}></AvatarItem>
                        )
                    )}
                </React.Fragment>
              </Col>
            </Row></div>)}
        {isInviteOpen && (<InvitePeopleModal
          socket={socket}
          onClose={() => { setIsInviteOpen(false) }}
          page={false}
        />)}
      </Modal>
    </React.Fragment>
  );
};

export default PeopleListModal;
